import { useQuery } from '@tanstack/react-query';
import { deleteSelected } from "../orgPanelApiCalls";

const key = 'deleteSelected';

const useDeleteSelectedQuery = (accountIds) => {
    return useQuery({ queryKey: [key], queryFn: () => deleteSelected(accountIds) })
}

export { useDeleteSelectedQuery, key };
